import styles from "./TitleIssueStatusChip.module.scss";

type Status = "Titled" | "Untitled" | "Not checked";
export const TitleStatusChip = ({
  status,
  outerClassName,
}: {
  status: Status;
  outerClassName?: string;
}) => {
  const getStatusClassName = (status: Status) => {
    if (status === "Titled") return styles.statusTitled;
    if (status === "Untitled") return styles.statusUntitled;
    return styles.statusTitled;
  };

  return (
    <div
      className={`${styles.statusSection} ${
        styles?.[outerClassName ?? ""] ?? ""
      }`}
    >
      <span
        className={`${styles.status} ${getStatusClassName(status)}`}
        role="status"
      >
        {status}
      </span>
    </div>
  );
};
